import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import {
  getSuperbillAnalyses,
  getSuperbillAnalysis,
  clearLocalSuperbillAnalyses,
  clearLocalActiveSuperbillAnalysis
} from './actions';

const initialState = {
  all: { data: [], pagination: { limit: 25, offset: 0, count: 0, total_count: 0 }},
  superbillAnalysis: { id: '', result: '', status: '', updated_at: '' },
  loading: { all: false, superbillAnalysis: false }
};

const slice = createSlice({
  name: 'superbillAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getSuperbillAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getSuperbillAnalyses.fulfilled, (state, action) => {
        const { superbill_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...superbill_analyses], 'id');
        
        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getSuperbillAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getSuperbillAnalysis.pending, (state) => {
        state.loading.superbillAnalysis = true;
      })
      .addCase(getSuperbillAnalysis.fulfilled, (state, action) => {
        const { data: { superbill_analysis }, cable } = action.payload;
        const foundedSuperbillAnalysis = !!_find(state.all.data, (s) => s.id === superbill_analysis.id);
        const updatedSuperbillAnalysis = { ...state.superbillAnalysis, ...superbill_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedSuperbillAnalysis ? _map(state.all.data, (e) => e.id === superbill_analysis.id ? { ...e, ...superbill_analysis } : e) : [...[superbill_analysis], ...oldAllData]; 
        const pagination = foundedSuperbillAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.superbillAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedSuperbillAnalysis && !cable) state.superbillAnalysis = updatedSuperbillAnalysis;       
      })
      .addCase(getSuperbillAnalysis.rejected, (state) => {
        state.loading.superbillAnalysis = false;
      })
      .addCase(clearLocalSuperbillAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveSuperbillAnalysis, state => {
        state.superbillAnalysis = initialState.superbillAnalysis;
      })
  }
})

export default slice.reducer;